import { useEffect, useCallback, useRef } from "react";
import { connect } from "react-redux";

const LAYER_FLOOD_SERVER = ({ layer, genangan_reducer }) => {
  const renderedKeysRef = useRef(new Set());

  const on_render = useCallback(() => {
    const { map_object } = layer;

    if (map_object) {
      const { geo_layer_list, layer_id } = layer;
      const { polygon_key_active_array, visibility_flood } = genangan_reducer;

      const geo_layer = geo_layer_list.find(
        (item) => item?.geo_layer?._id === layer_id
      )?.geo_layer;
      const features_flood_all = geo_layer?.features_flood_all || [];

      const features = geo_layer?.geojson?.features || [];
      const polygon_flood_feature_key_array = [];

      features.forEach((item) => {
        if (item?.properties?.polygon_flood_feature_key)
          polygon_flood_feature_key_array.push(
            item?.properties?.polygon_flood_feature_key
          );
      });

      const features_flood_current = features_flood_all.filter((item) =>
        polygon_flood_feature_key_array.includes(item?.key)
      );

      const currentKeys = new Set(features_flood_current.map((f) => f.key));

      renderedKeysRef.current.forEach((libre_id) => {
        if (!currentKeys.has(libre_id)) {
          if (map_object.getLayer(libre_id + "line")) {
            map_object.removeLayer(libre_id + "line");
          }
          if (map_object.getLayer(libre_id + "poly")) {
            map_object.removeLayer(libre_id + "poly");
          }
          if (map_object.getSource(libre_id)) {
            map_object.removeSource(libre_id);
          }
          renderedKeysRef.current.delete(libre_id);
        }
      });

      features_flood_current.forEach((feature) => {
        const libre_id = feature.key;
        let visibility = polygon_key_active_array.includes(
          feature?.properties?.point_flood_feature_key
        )
          ? "visible"
          : "none";

        if (visibility_flood === "none") {
          visibility = "none";
        }

        const geojson = {
          type: "FeatureCollection",
          features: [feature],
        };

        if (!map_object.getSource(libre_id)) {
          map_object.addSource(libre_id, {
            type: "geojson",
            data: geojson,
          });
        } else {
          map_object.getSource(libre_id).setData(geojson);
        }

        if (!map_object.getLayer(libre_id + "poly")) {
          map_object.addLayer({
            id: libre_id + "poly",
            source: libre_id,
            type: "fill",
            paint: {
              "fill-color": "blue",
              "fill-opacity": 0.2,
            },
            layout: { visibility },
          });
        } else {
          map_object.setLayoutProperty(
            libre_id + "poly",
            "visibility",
            visibility
          );
        }

        if (!map_object.getLayer(libre_id + "line")) {
          map_object.addLayer({
            id: libre_id + "line",
            source: libre_id,
            type: "line",
            paint: {
              "line-color": "blue",
              "line-opacity": 1,
              "line-width": 1,
            },
            layout: { visibility },
          });
        } else {
          map_object.setLayoutProperty(
            libre_id + "line",
            "visibility",
            visibility
          );
        }

        renderedKeysRef.current.add(libre_id);
      });
    }
  }, [layer, genangan_reducer]);

  useEffect(() => {
    const { map_object } = layer;
    if (map_object) {
      on_render();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    genangan_reducer?.genangan_update,
    genangan_reducer?.polygon_key_active_array?.length,
    genangan_reducer?.visibility_flood,
  ]);

  return <main></main>;
};

const mapStateToProps = (state) => ({
  layer: state.layer,
  properties: state.properties,
  genangan_reducer: state.genangan_reducer,
});

export default connect(mapStateToProps, {})(LAYER_FLOOD_SERVER);
